import Carga from '@/model/resource/Carga'
import CargaCsvSimplesSemQtdFotoObservacaoColetaSchema from '@/schema/CargaCsvSimplesSemQtdFotoObservacaoColeta.schema'

export default class CargaCsvSimplesSemQtdFotoObservacaoColeta extends Carga {

    get $schema() {
        return CargaCsvSimplesSemQtdFotoObservacaoColetaSchema(this)
    }

}
